import React from "react";

const categories = [
  {
    title: "Toyota Etios",
    cars: 1,
    img: "/images/fleet/Toyota-Etios.jpg",
  },
  {
    title: "Toyota Innova",
    cars: 1,
    img: "/images/fleet/Toyota-Innova.jpg",
  },
  {
    title: "Honda Amaze",
    cars: 1,
    img: "/images/fleet/Honda-Amaze.jpg",
  },
  {
    title: "Toyota Corolla Altis",
    cars: 1,
    img: "/images/fleet/Toyota-corolla-Altis.jpg",
  },
  {
    title: "Maruti Ertiga",
    cars: 1,
    img: "/images/fleet/Maruti-Ertiga.jpg",
  },
  {
    title: "Maruti Swift Dzire",
    cars: 1,
    img: "/images/fleet/Maruti-swift-Dzire.jpg",
  },
];

const FeaturedCategories = () => {
  return (
    <section className="category-section-four">
      <div className="container">
        <div className="row">
          <div className="col-md-12">

            {/* Heading */}
            <div className="section-heading heading-four" data-aos="fade-down">
              <h2>SRS Cab Service Fleet</h2>
              <p>
                Choose from our wide range of comfortable and reliable cabs for city rides, airport transfers, and outstation trips
              </p>
            </div>

            <div className="row row-gap-4">
              {categories.map((category, index) => (
                <div key={index} className="col-xl-2 col-md-4 col-sm-6 d-flex ">
                  <div className="category-item flex-fill">
                    <div className="category-info d-flex align-items-center justify-content-between titlee">
                      <div>
                        <h6 className="title">
                          <a href="/booking" className="titlee">{category.title}</a>
                        </h6>
                        {/* <p>{category.cars} Vehicle</p> */}
                      </div>
                      <a href="/booking" className="link-icon">
                        <i className="bx bx-right-arrow-alt"></i>
                      </a>
                    </div>

                    <div className="category-img">
                      <img
                        src={category.img}
                        alt={category.title}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCategories;